export default {
    initialize_app: () => {
        return {
            url: '/initialize',
            method: 'GET'
        };
    }
};



// WEBPACK FOOTER //
// ./scenes/Splashpage/api.js